'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
const StyledSvg = styled('svg')(({ theme }) => ({
    width: '32px',
    height: '32px',
    flexShrink: 0,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
        width: '24px',
        height: '24px'
    }
}));
const PickerCircle = ({ color, className }) => {
    return (_jsxs(StyledSvg, { width: "33", height: "32", viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className, "aria-label": `Color picker circle in ${color}`, children: [_jsx("circle", { cx: "16.5", cy: "16", r: "16", fill: "white" }), _jsx("circle", { cx: "16.5", cy: "16", r: "15.5", stroke: "black", strokeOpacity: "0.1" }), _jsx("circle", { cx: "16.5", cy: "16", r: "8", fill: color }), _jsx("circle", { cx: "16.5", cy: "16", r: "7.5", stroke: "black", strokeOpacity: "0.1" })] }));
};
export default PickerCircle;
